import { SectionSeparator } from "../../atom/SectionSeparator";
import { StartingCard } from "../dashboard/main/exam/StartingCard";
import React from "react";
import { useTranslation } from "react-i18next";
import { NoExams } from "../../molecules/exam/NoExams";
import { ParticipantExam } from "../../../types/components";
import { getResponsiblePersons } from "../../../utils/exam";

interface EnrolledExamsProps {
  data?: ParticipantExam[] | null;
}

export const EnrolledExams: React.FC<EnrolledExamsProps> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div className="px-[52px] mt-14 pt-8 flex flex-col gap-14">
      <SectionSeparator label={t("Enrolled")} />

      <div
        className={`grid gap-10 pb-10 ${data && data.length > 0 ? "grid-cols-2" : "grid-cols-1"}`}>
        {data?.map(({ exam, is_completed, id }) => {
          const {
            id: examId,
            code,
            exam_type,
            questions_number,
            responsible_persons,
            is_finished,
            date_from,
            date_to,
            status,
          } = exam;
          const authorizedPerson = getResponsiblePersons(responsible_persons);
          const startDate = date_from ?? "";
          const endDate = date_to ?? "";
          const secondsUntilStart = exam?.seconds_until_start ?? 0;
          const secondsUntilEnd = exam?.seconds_until_end ?? 0;

          return (
            <StartingCard
              key={id}
              id={id}
              examId={examId}
              title={code}
              type={exam_type?.name}
              questions={questions_number}
              authorizedPerson={authorizedPerson}
              startDate={startDate}
              is_completed={is_completed}
              is_finished={is_finished}
              endDate={endDate}
              examStatusCode={status?.code}
              secondsUntilStart={secondsUntilStart}
              secondsUntilEnd={secondsUntilEnd}
            />
          );
        })}
        {data?.length === 0 && <NoExams label="No exams." />}
      </div>
    </div>
  );
};
